import React from "react";
import "./SectorsSection.css";

const IndustrialTrustSection = () => {
  const sectors = [
    "Manufacturing Plants",
  "Automobile Industry",
  "Pharmaceutical Units",
  "Food Processing Plants",
  "Chemical Industries",
  "Textile Mills",
  "Warehouses & Distribution Centers",
  "Logistics Facilities",
  "Cold Storage Units",
  "Engineering Units",
  "Metal Fabrication",
  "Electronics Manufacturing"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustrialTrustSection;
